import { atom, PrimitiveAtom } from 'jotai'

import { currentEnv } from '@/env/vars.ts'
import { queryClient } from '@/QueryClient'
import { store } from '@/store'
import { ITopic } from '@/types/helpCenter'
import { GET, POST } from '@/utils/fetch'

export const helpCenterTopicsAtom = atom<ITopic[]>([])
export const helpCenterSelectedTopicAtom: PrimitiveAtom<ITopic | null> = atom<ITopic | null>(null)
export const showHelpCenterDrawerAtom: PrimitiveAtom<boolean> = atom<boolean>(false)

export const getTopics = async () => {
    const res = await queryClient.fetchQuery({
        queryKey: ['topics'],
        queryFn: () => GET<ITopic[]>(`${currentEnv.utilityUrl}/topics`),
    })
    if (res) {
        store.set(helpCenterTopicsAtom, res)
    }
}

export const sendHelpData = async ({ title, message, id }: { title: string; message: string; id: number }) => {
    return await POST(`${currentEnv.utilityUrl}/feedbacks`, {
        topicId: id,
        basicDetails: title,
        fullDetails: message,
    })
}

export const getSelectedTopic = (topics: ITopic[], topicId: number): ITopic => {
    return topics.find((topic) => topic.id === topicId) as ITopic
}
